import { createSlice } from '@reduxjs/toolkit';
// import { findOverlapLength } from '../../utils/misc';

// Helper to get from localStorage or fallback
const getFromLocal = (key, defaultValue) => {
  const stored = localStorage.getItem(key);
  try {
    return stored !== null ? JSON.parse(stored) : defaultValue;
  } catch {
    return defaultValue;
  }
};

const getSystemTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

const initialState = {
  companyName: getFromLocal("companyName", ""),
  contactEmail: getFromLocal("contactEmail", ""),
  logoCompact: getFromLocal("logoCompact", ""),
  isTabSwitchingEnabled: getFromLocal("isTabSwitchingEnabled", false),
  logoPrimary: getFromLocal("logoPrimary", ""),
  logoPrimaryDark: getFromLocal("logoPrimaryDark", ""),
  pdfWatermark: getFromLocal("pdfWatermark", ""),
  brandingLogo: getFromLocal("brandingLogo", false),
  whitelabelEnabled: getFromLocal("currentTheme", true),
  theme: getFromLocal("appTheme", getSystemTheme()),
  showDeletePopup: false,
  candidateResponse: "",
  assemblyTtsEnabled: getFromLocal("assemblyTtsEnabled", false),
  assemblySpeechModel: getFromLocal("assemblySpeechModel", null),
  assemblyLanguageCodes: getFromLocal("assemblyLanguageCodes", null),
  isjdcreated: getFromLocal("isjdcreated", false)
};

export const miscSlice = createSlice({
  name: 'miscSlice',
  initialState,
  reducers: {
    updateData: (state, action) => {
      const fields = [
        "companyName",
        "contactEmail",
        "logoCompact",
        "logoPrimary",
        "logoPrimaryDark",
        "pdfWatermark",
        "whitelabelEnabled"
      ];

      fields.forEach((field) => {
        if (field in action.payload) {
          if (field === "whitelabelEnabled") {
            state.brandingLogo = true;
            return;
          }
          state[field] = action.payload[field];

          // For whitelabelEnabled, store as boolean
          localStorage.setItem(
            field === "whitelabelEnabled" ? "currentTheme" : field,
            JSON.stringify(action.payload[field])
          );
        }
      });
    },
    toggleThemeReducer: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      state.whitelabelEnabled = state.theme === 'light' ? true : false;
      localStorage.setItem("appTheme", JSON.stringify(state.theme));
    },

    // Transient theme override (NOT persisted). Used by the public report, which
    // forces dark for its viewers and restores the previous value on unmount.
    setThemeReducer: (state, action) => {
      state.theme = action.payload === 'dark' ? 'dark' : 'light';
      state.whitelabelEnabled = state.theme === 'light';
    },

    updateConfigData: (state, action) => {
      const { isTabSwitchingEnabled, assemblyTtsEnabled, assemblySpeechModel, assemblyLanguageCodes } = action.payload;
      if (isTabSwitchingEnabled !== undefined) {
        state.isTabSwitchingEnabled = isTabSwitchingEnabled;
        localStorage.setItem("isTabSwitchingEnabled", JSON.stringify(isTabSwitchingEnabled));
      }
      if (assemblyTtsEnabled !== undefined) {
        state.assemblyTtsEnabled = assemblyTtsEnabled;
        localStorage.setItem("assemblyTtsEnabled", JSON.stringify(assemblyTtsEnabled));
      }
      if (assemblySpeechModel !== undefined) {
        state.assemblySpeechModel = assemblySpeechModel;
        localStorage.setItem("assemblySpeechModel", JSON.stringify(assemblySpeechModel));
      }
      if (assemblyLanguageCodes !== undefined) {
        state.assemblyLanguageCodes = assemblyLanguageCodes;
        localStorage.setItem("assemblyLanguageCodes", JSON.stringify(assemblyLanguageCodes));
      }
    },

    setShowDeletePopup: (state, action) => {
      state.showDeletePopup = action.payload;
    },

    updateCandidateResponse: (state, action) => {
      const incoming = action.payload?.trim();
      if (!incoming) return;
      state.candidateResponse += incoming;
      // if (!state.candidateResponse) {
      //   // Case 1: first chunk
      //   state.candidateResponse = incoming;
      //   return;
      // }

      // const existing = state.candidateResponse;

      // // Case 2: full duplicate — the incoming text is already in the string
      // if (existing.toLowerCase().includes(incoming.toLowerCase())) {
      //   return; // stale/duplicate chunk, skip
      // }

      // // Case 3: find partial overlap between end of existing and start of incoming
      // const overlapLen = findOverlapLength(existing, incoming);

      // if (overlapLen > 0) {
      //   // Append only the non-overlapping tail
      //   const newTail = incoming.slice(overlapLen);
      //   state.candidateResponse = existing + newTail;
      // } else {
      //   // No overlap — append with a space separator
      //   state.candidateResponse = existing + " " + incoming;
      // }
    },
    resetCandidateResponse: (state) => {
      state.candidateResponse = "";
    },
    toggleisjdcreated: (state, action) => {
      state.isjdcreated = action.payload;
    }
  }
});

export const { updateData, toggleThemeReducer, setThemeReducer, updateConfigData, setShowDeletePopup, updateCandidateResponse, resetCandidateResponse, toggleisjdcreated } = miscSlice.actions;
export default miscSlice.reducer;
